import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'

import { AuthToken } from '../../providers/auth/helpers'
import { useAuth } from '../../providers'
import { QuestionModal, Text } from '../../components'

import { useStyle } from './delete-account.styles'
import { DeleteAccountProps } from './delete-account.types'

export const DeleteAccountModal: FC<DeleteAccountProps> = ({
  open,
  onClose,
  onSubmit
}) => {
  const token = localStorage.getItem(AuthToken.TOKEN) as string
  const classes = useStyle()
  const history = useHistory()

  const { onAccountDelete } = useAuth()

  const handleOnToRefreshClick = () => {
    window.location.reload()
  }
  const handleOnSubmit = () => {
    if (onAccountDelete) {
      onAccountDelete({
        token
      })
    }
  }
  const handleOnClick = () => {
    history.push('/')
    handleOnToRefreshClick()
    handleOnSubmit()
    onSubmit()
  }

  if (!open) {
    return <></>
  }

  return (
    <QuestionModal
      classNameContainer={classes.container}
      className={classes.modal}
      title="Delete Account"
      titleTx="delete.account.title.text"
      successText="Delete Account"
      successTx="delete.account.title.text"
      cancelText="Cancel"
      cancelTx="choose.vendor.button.text"
      onClose={onClose}
      onSubmit={handleOnClick}
    >
      <Text
        className={classes.title}
        color="darkBlue"
        preset="h4"
        text="Are you sure?"
        tx="declineOrder.modal.secondaryTitle"
      />
      <Text
        className={classes.description}
        color="inactive"
        preset="body"
        text="Deleting your account will remove all of your information from our database. This cannot be undone."
        tx="delete.account.secondary.text"
      />
    </QuestionModal>
  )
}
